import React, { Component } from "react";
import CSVFileUploader from "./CSVFileUploader";
import UploadFileStatus from "./UploadFileStatus";
import PopUp from "./PopUp";
import FileUploadMetrics from "./FileUploadMetrics";
import { connect } from "react-redux";
import { withRouterHooks } from "../../../withRouters/withRoutersHook";
import PropTypes from "prop-types";
import { ResetAnalysisReduxStateAction } from "../../../Actions/Analysis";
import { GetUserAction } from "../../../Actions/Authentication";
import { BookOpen, MessageSquarePlus } from "lucide-react";
import { Link } from "react-router-dom";
class DashboardHome extends Component {
  static propTypes = {
    csvFileUploadSuccess: PropTypes.bool,
    ResetAnalysisReduxStateAction: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    GetUserAction: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.ResetAnalysisReduxStateAction();
    this.props.GetUserAction();
  }

  handlePath = () => {
    let text = "";
    if (this.props.location.pathname === "/dashboard") {
      text = "SurveyIQ Upload Metrics";
    } else if (this.props.location.pathname === "/dashboard/pdf-analyzer") {
      text = "SmartExtract Upload Metrics";
    }

    return text;
  };

  render() {
    return (
      <div
        className="relative flex w-full border-l"
        style={{
          background:
            "radial-gradient(ellipse at top left, #dbeafe 0%, transparent 50%), radial-gradient(ellipse at top right, #e0e7ff 0%, transparent 50%), radial-gradient(ellipse at bottom center, #eff6ff 0%, transparent 60%), #f8faff",
        }}
      >
        {this.props.csvFileUploadSuccess && <PopUp />}
        <div className="w-full flex flex-col px-4 md:px-8 pt-6 md:pt-8 pb-16 gap-6">
          <div className="flex flex-col w-full gap-3">
            {/* Page header row */}
            <div className="flex items-center justify-between">
              <h1 className="font-SFPro font-bold text-2xl text-gray-900">
                {this.handlePath()}
              </h1>
              <div className="flex items-center gap-2">
                <Link
                  to="/dashboard/docs"
                  className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-gradient-to-r from-gray-50 to-gray-100 border border-gray-200 text-sm font-medium text-gray-600 hover:from-gray-100 hover:to-gray-200 hover:text-gray-900 transition-all duration-150 font-inter focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  <BookOpen className="w-4 h-4" />
                  <span>Docs</span>
                </Link>
                <a
                  href="#"
                  className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-gradient-to-r from-primary-blue to-blue-400 text-white text-sm font-medium hover:from-blue-600 hover:to-blue-500 transition-all duration-150 font-inter shadow-sm"
                >
                  <MessageSquarePlus className="w-4 h-4" />
                  <span>Send Feedback</span>
                </a>
              </div>
            </div>
            <FileUploadMetrics />
          </div>
          <CSVFileUploader />
          <UploadFileStatus />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  csvFileUploadSuccess: state.analysis.csvFileUploadSuccess,
});

export default withRouterHooks(
  connect(mapStateToProps, { ResetAnalysisReduxStateAction, GetUserAction })(
    DashboardHome
  )
);
